export const navLinks = [
  { label: "Início", href: "#top" },
  { label: "Serviços", href: "#servicos" },
  { label: "Cases", href: "#cases" },
  { label: "Sobre", href: "#sobre" },
  { label: "Contato", href: "#contato" },
];

export const whatsappUrl = "https://wa.me/5521989013039";
export const instagramUrl = "https://www.instagram.com/serraconsultoria";
export const contactEmail = "contato@serraconsultoria.com";
export const contactPhone = "(21) 98901-3039";
export const contactAddress =
  "Edifício Fórum Empresarial da Taquara — Taquara, Rio de Janeiro - RJ, 22730-522";

export const heroOrbitIcons = [
  { icon: "ri-global-line", label: "Sites" },
  { icon: "ri-shopping-cart-line", label: "E-commerce" },
  { icon: "ri-settings-4-line", label: "Softwares" },
  { icon: "ri-line-chart-line", label: "Tráfego Pago" },
  { icon: "ri-smartphone-line", label: "Redes Sociais" },
  { icon: "ri-graduation-cap-line", label: "LMS" },
  { icon: "ri-palette-line", label: "Identidade Visual" },
  { icon: "ri-map-pin-line", label: "Google Empresas" },
];

export const clientLogos = [
  { name: "Ma Gádeni", image: "/clients/ma-gadeni.png" },
  { name: "Revvo", image: "/clients/revvo.png" },
  { name: "Sebraci", image: "/clients/sebraci.png", invert: true },
  { name: "Afetuário", image: "/clients/afetuario.png" },
  { name: "Donnos", image: "/clients/donnos.png" },
  { name: "Zschimmer & Schwarz", image: "/clients/zschimmer-schwarz.jpg" },
  { name: "BP9 Antecipa", image: "/clients/bp9-antecipa.png" },
  { name: "Farma Performance", image: "/clients/farma-performance.png" },
  { name: "Clínica de Ayurveda", image: "/clients/clinica-ayurveda.png" },
  { name: "Miau de Casa", image: "/clients/miaudecasa.png" },
  { name: "Bozzetti Store", image: "/clients/bozzetti-store.png" },
  { name: "PIB", image: "/clients/pib.png", invert: true },
  { name: "Ray Melo", image: "/clients/ray-melo.png" },
  { name: "New Tech Solution", image: "/clients/new-tech-solution.webp" },
  { name: "Smart Control", image: "/clients/smart-control.webp" },
  { name: "JR Sublimação", image: "/clients/jr-sublimacao.png" },
  { name: "Projeto Impacto", image: "/clients/projeto-impacto.png" },
  { name: "Santa Casa de Misericórdia do Rio de Janeiro", image: "/clients/santa-casa-misericordia.png", invert: true },
];

export const services = [
  {
    icon: "ri-global-line",
    title: "Criação de Sites",
    desc: "Desenvolvemos sites e landing pages personalizados, unindo design, tecnologia e estratégia para fortalecer sua marca, aumentar sua autoridade e gerar mais oportunidades de negócio.",
  },
  {
    icon: "ri-shopping-cart-line",
    title: "Criação de E-commerce",
    desc: "Criamos lojas virtuais de alta performance, preparadas para vender 24 horas por dia, oferecendo uma experiência de compra rápida, segura e otimizada para aumentar suas vendas.",
  },
  {
    icon: "ri-settings-4-line",
    title: "Softwares e Programas Personalizados",
    desc: "Desenvolvemos sistemas sob medida para automatizar processos, integrar setores e aumentar a produtividade da sua empresa com soluções escaláveis e de alto desempenho.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Tráfego Pago",
    desc: "Planejamos e gerenciamos campanhas no Google Ads e Meta Ads para atrair clientes qualificados, aumentar as conversões e maximizar o retorno sobre o seu investimento.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Gerenciamento de Redes Sociais",
    desc: "Criamos estratégias de conteúdo que fortalecem sua presença digital, aumentam o engajamento e aproximam sua marca do público certo de forma consistente.",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "Plataforma LMS",
    desc: "Implantamos plataformas completas para treinamentos corporativos e cursos online, com gestão de alunos, trilhas de aprendizagem, certificados e acompanhamento de desempenho.",
  },
  {
    icon: "ri-palette-line",
    title: "Identidade Visual",
    desc: "Criamos logotipos e identidades visuais que transmitem profissionalismo, fortalecem o posicionamento da sua marca e tornam sua empresa memorável.",
  },
  {
    icon: "ri-map-pin-line",
    title: "Google Empresas",
    desc: "Criamos, configuramos e otimizamos o perfil da sua empresa no Google Empresas e Google Maps, aumentando sua visibilidade nas pesquisas locais, fortalecendo sua credibilidade e facilitando que novos clientes encontrem e entrem em contato com o seu negócio.",
  },
];

export const differentials = [
  { number: "01", title: "Diagnóstico", desc: "Mapeamos seu momento digital, público e concorrência." },
  { number: "02", title: "Estratégia", desc: "Definimos posicionamento e a rota de crescimento ideal." },
  { number: "03", title: "Planejamento", desc: "Estruturamos entregas, prazos e prioridades com clareza." },
  { number: "04", title: "Execução", desc: "Construímos com tecnologia de ponta e atenção ao detalhe." },
  { number: "05", title: "Otimização", desc: "Refinamos com dados reais de uso e performance." },
  { number: "06", title: "Escala", desc: "Expandimos o que funciona para crescer com consistência." },
];

export const stats = [
  { value: 200, suffix: "+", label: "Projetos" },
  { value: 98, suffix: "%", label: "Clientes satisfeitos" },
  { value: 350, suffix: "%", label: "Média de crescimento" },
  { value: 5, suffix: " anos", label: "de experiência" },
];

export interface PortfolioItem {
  title: string;
  category: string;
  image: string;
  featured?: boolean;
}

export const portfolio: PortfolioItem[] = [
  { title: "Ma Gádeni", category: "E-commerce & Branding", image: "/portfolio/ma-gadeni.png", featured: true },
  { title: "Passo Feliz", category: "Sistema Web", image: "/portfolio/passo-feliz.png", featured: true },
  { title: "Portal do Contador", category: "Sistema Web", image: "/portfolio/portal-contador-1.png", featured: true },
  { title: "Intnet", category: "Landing Page", image: "/portfolio/intnet.png", featured: true },
  { title: "BP9 Antecipa", category: "Landing Page", image: "/portfolio/bp9-antecipa.png", featured: true },
  { title: "Sebraci", category: "Site Institucional", image: "/portfolio/sebraci.png", featured: true },
  { title: "Link Registros", category: "Landing Page", image: "/portfolio/link-registros.png" },
  { title: "DeskFlow", category: "Sistema Web", image: "/portfolio/desk-flow-1.png" },
  { title: "Farma Performance", category: "Sistema Web", image: "/portfolio/farma-performance-1.png" },
  { title: "New Tech Solution", category: "Site Institucional", image: "/portfolio/new-tech-solution.png" },
  { title: "Donnos", category: "Site Institucional", image: "/portfolio/donno-vendas.png" },
  { title: "JR Gráfica e Sublimação", category: "Site Institucional", image: "/portfolio/jr-grafica-sublimacao.png" },
  { title: "Estrela Dalva", category: "Site Institucional", image: "/portfolio/estrela-dalva.png" },
  { title: "Clínica", category: "Site Institucional", image: "/portfolio/clinica.png" },
  { title: "Mega Açaí", category: "Site Institucional", image: "/portfolio/mega-acai.png" },
  { title: "Bozzetti", category: "Site Institucional", image: "/portfolio/bozzetti.jpg" },
  { title: "Luxere", category: "Site Institucional", image: "/portfolio/luxere.png" },
  { title: "Miau de Casa", category: "E-commerce", image: "/portfolio/miau-de-casa.png" },
  { title: "Alma Bistrô", category: "Site Institucional", image: "/portfolio/alma-bistro.png" },
  { title: "Santa Casa de Misericórdia", category: "Site Institucional", image: "/portfolio/santa-casa-misericordia.png" },
  { title: "Dr. João", category: "Site Institucional", image: "/portfolio/dr-joao.png" },
  { title: "Agropecuária Yguazu", category: "Landing Page", image: "/portfolio/agropecuaria-yguazu.png" },
  { title: "João Dutra", category: "Site Institucional", image: "/portfolio/joao-dutra.png" },
  { title: "Pintando o Sete", category: "Site Institucional", image: "/portfolio/pintando-o-sete.png" },
  { title: "O Peralta", category: "Site Institucional", image: "/portfolio/o-peralta.png" },
];

export const techStack = [
  "react",
  "nodedotjs",
  "typescript",
  "nextdotjs",
  "flutter",
  "supabase",
  "firebase",
  "amazonaws",
  "docker",
];
